import React from 'react'
import PropTypes from 'prop-types'

import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'

import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';

const ThemeSelector = ({organization, onOrganizationChange}) => {

  const handleThemeChange = (event, newTheme) => {    
    if (newTheme !== null) {
      const newOrganization = { ...organization, theme: newTheme }; 
      onOrganizationChange(newOrganization)
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <ToggleButtonGroup
        value={organization.theme || 'light'}
        exclusive
        onChange={handleThemeChange}
        fullWidth
        size="large"
        sx={{
          '& .MuiToggleButtonGroup-grouped': {
            borderRadius: 1,
            py: 1.5,
          },
        }}
      >
        <ToggleButton value="light" aria-label="light theme">
          <LightModeOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
          <Typography sx={{ fontWeight: 500 }}>LIGHT</Typography>
        </ToggleButton>
        <ToggleButton value="dark" aria-label="dark theme">
          <DarkModeOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
          <Typography sx={{ fontWeight: 500 }}>DARK</Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

ThemeSelector.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
};

export default ThemeSelector;